import { SiteFooterProps } from "./SiteFooter.contract";
import { LEGAL_OWNER_COPYRIGHT } from "../../../lib/legal/config";

const footerLinks = [
  { label: "Start", page: "start" as const },
  { label: "About", page: "about" as const },
  { label: "Support", page: "support" as const },
  { label: "Privacy", page: "privacy" as const },
  { label: "Terms", page: "terms" as const },
  { label: "Cookies", page: "cookies" as const },
  { label: "Security", page: "security" as const },
  { label: "Acceptable Use", page: "acceptable-use" as const },
];

export function SiteFooter({ navigateToPage }: SiteFooterProps) {
  return (
    <footer
      className="w-full border-t border-black/10 bg-[rgba(247,245,240,0.76)] mt-12"
      aria-label="Site footer"
    >
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 py-8 grid grid-cols-1 lg:grid-cols-[1.2fr_1fr] gap-8">
        <section aria-label="Brand summary" className="space-y-3">
          <h2 className="text-lg font-bold text-brand-ink tracking-[-0.02em]">Monyawn</h2>
          <p className="text-sm text-brand-muted leading-relaxed max-w-[62ch]">
            Local-first, AI-native opportunity management for high-stakes career moves. Structure
            signals, organize proof, and control your story with private-by-default workflows.
          </p>
          <p className="text-xs text-brand-muted/90">
            Brand intent: clarity, evidence, and durable handoff quality.
          </p>
          <p className="text-xs text-brand-muted/90">{LEGAL_OWNER_COPYRIGHT}</p>
        </section>

        <nav aria-label="Discoverability links" className="flex flex-col gap-3 lg:items-end">
          <p className="text-[10px] uppercase tracking-[0.18em] font-bold text-brand-muted">
            Explore
          </p>
          <div className="flex flex-wrap gap-2 lg:justify-end">
            {footerLinks.map((link) => (
              <button
                key={link.page}
                type="button"
                onClick={() => navigateToPage(link.page)}
                className="text-sm px-3 py-2 rounded-full border border-black/10 bg-white/70 text-brand-ink font-semibold hover:bg-black/5 transition-colors"
              >
                {link.label}
              </button>
            ))}
            <a
              href="https://github.com/cadguardianllc/sbs_opportunity_management_panel"
              target="_blank"
              rel="noreferrer"
              className="text-sm px-3 py-2 rounded-full border border-black/10 bg-white/70 text-brand-ink font-semibold hover:bg-black/5 transition-colors"
            >
              Technical docs
            </a>
          </div>
        </nav>
      </div>
    </footer>
  );
}
